import React, { Component } from "react";
import { Link } from "react-router-dom";
import { Dropdown, DropdownToggle, DropdownMenu, Row, Col } from "reactstrap";
import SimpleBar from "simplebar-react";

//i18b
import { withTranslation } from "react-i18next";

//Import images
import avatar4 from "../../assets/images/users/avatar-4.jpg";
import teacher from "../../assets/images/brands/teacher.jpg"
import school from "../../assets/images/brands/school.jpg"

class NotificationDropdown extends Component {
    constructor(props) {
        super(props);
        this.state = {
            menu: false
        };
        this.toggle = this.toggle.bind(this);
    }

    toggle() {
        this.setState(prevState => ({
            menu: !prevState.menu
        }));
    }
    render() {
        return (
            <React.Fragment>
                <Dropdown isOpen={this.state.menu} toggle={this.toggle} className="d-inline-block">
                    <DropdownToggle tag="button" className="btn header-item noti-icon waves-effect" id="page-header-notifications-dropdown">
                        <i className="ri-notification-3-line"></i>
                        <span className="noti-dot"></span>
                    </DropdownToggle>
                    <DropdownMenu className="dropdown-menu-end dropdown-menu-lg p-0"
                        aria-labelledby="page-header-notifications-dropdown">
                        <div className="p-3">
                            <Row className="align-items-center">
                                <Col>
                                    <h6 className="m-0"> {this.props.t('Notifications')} </h6>
                                </Col>
                                <div className="col-auto">
                                    <Link to="#" className="small"> {this.props.t('View All')}</Link>
                                </div>
                            </Row>
                        </div>
                        <SimpleBar style={{ maxHeight: "230px" }}>

                            <Link to="#" className="text-reset notification-item">
                                <div className="d-flex">
                                    <img src={avatar4} className="me-3 rounded-circle avatar-xs" alt="user-pic" />
                                    <div className="flex-1">
                                        <h6 className="mt-0 mb-1">{this.props.t('Salena Layfield')}</h6>
                                        <div className="font-size-12 text-muted">
                                            <p className="mb-1">{this.props.t('As a skeptical Cambridge friend of mine occidental.')}</p>
                                            <p className="mb-0"><i className="mdi mdi-clock-outline"></i> {this.props.t('12 minutes ago')}</p>
                                        </div>
                                    </div>
                                </div>
                            </Link>

                            <Link to="#" className="text-reset notification-item">
                                <div className="d-flex">
                                    <img src={avatar4} className="me-3 rounded-circle avatar-xs" alt="user-pic" />
                                    <div className="flex-1">
                                        <h6 className="mt-0 mb-1">{this.props.t('Parents Meeting Scheduled')}</h6>
                                        <div className="font-size-12 text-muted">
                                            <p className="mb-1">{this.props.t(' Dear Parent, We invite you to attend the upcoming Parents Meeting on March 5.')}</p>
                                            <p className="mb-0"><i className="mdi mdi-clock-outline"></i> {this.props.t('2 hours ago')}</p>
                                        </div>
                                    </div>
                                </div>
                            </Link>

                            <Link to="#" className="text-reset notification-item">
                                <div className="d-flex">
                                    <img src={teacher} className="me-3 rounded-circle avatar-xs" alt="user-pic" />
                                    <div className="flex-1">
                                        <h6 className="mt-0 mb-1">{this.props.t('Report Card Available')}</h6>
                                        <div className="font-size-12 text-muted">
                                            <p className="mb-1">{this.props.t('  Dear Parent, your child s report card is now available.')}</p>
                                            <p className="mb-0"><i className="mdi mdi-clock-outline"></i> {this.props.t('2 days ago')}</p>
                                        </div>
                                    </div>
                                </div>
                            </Link>

                            <Link to="#" className="text-reset notification-item">
                                <div className="d-flex">
                                    <img src={teacher} className="me-3 rounded-circle avatar-xs" alt="user-pic" />
                                    <div className="flex-1">
                                        <h6 className="mt-0 mb-1">{this.props.t('Fee Updation')}</h6>
                                        <div className="font-size-12 text-muted">
                                            <p className="mb-1">{this.props.t(' School fees for this term are due on March 10, 2025.')}</p>
                                            <p className="mb-0"><i className="mdi mdi-clock-outline"></i> {this.props.t('5 days ago')}</p>
                                        </div>
                                    </div>
                                </div>
                            </Link>

                            <Link to="#" className="text-reset notification-item">
                                <div className="d-flex">
                                    <img src={school} className="me-3 rounded-circle avatar-xs" alt="user-pic" />
                                    <div className="flex-1">
                                        <h6 className="mt-0 mb-1">{this.props.t('Holiday Announcement')}</h6>
                                        <div className="font-size-12 text-muted">
                                            <p className="mb-1">{this.props.t('School will remain closed on March 8, 2025, for a public holiday. Enjoy your break!')}</p>
                                            <p className="mb-0"><i className="mdi mdi-clock-outline"></i> {this.props.t('10 days ago')}</p>
                                        </div>
                                    </div>
                                </div>
                            </Link>
                        </SimpleBar>
                        <div className="p-2 border-top">
                            <Link to="#" className="btn btn-sm btn-link font-size-14 btn-block text-center">
                                <i className="mdi mdi-arrow-right-circle me-1"></i>{this.props.t(' View More')}
                            </Link>
                        </div>
                    </DropdownMenu>
                </Dropdown>
            </React.Fragment>
        );
    }
}
export default withTranslation()(NotificationDropdown);
